const actions = {
  SET_STATE: 'statistic/SET_STATE',
  FETCH_DASHBOARD: 'statistic/dashboard/FETCH',
  FETCH_BASIC_MEMBERS_BY_SPORT: 'statistic/basic/member/sport/FETCH',
  FETCH_BASIC_REGISTRATIONS_BY_PLACE: 'statistic/basic/registrations/place/FETCH',
  FETCH_BASIC_MEMBERS_WITHOUT_CONSENT_BY_PLACE: 'statistic/basic/member-without-consent/place/FETCH',
  FETCH_REGISTRATION_PLACE: 'statistic/registration/place/FETCH',
  EXPORT_REGISTRATION_PLACE: 'statistic/registration/place/EXPORT',
  FETCH_REGISTRATION_SPORT: 'statistic/registration/sport/FETCH',
  EXPORT_REGISTRATION_SPORT: 'statistic/registration/sport/EXPORT',
  FETCH_MEMBER_PLACE: 'statistic/member/place/FETCH',
  EXPORT_MEMBER_PLACE: 'statistic/member/place/EXPORT',
  FETCH_MEMBER_SPORT: 'statistic/member/sport/FETCH',
  EXPORT_MEMBER_SPORT: 'statistic/member/sport/EXPORT',
  FETCH_REGISTRATION_SPORTS_BY_PLACE: 'statistic/sport/place/FETCH',
};

export default actions
